import {ChangeDetectionStrategy, Component, inject, input, OnInit} from '@angular/core';
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../../types/product-card-files.types";
import {CertificateFilesStateService} from "../../services/certificate-files-state.service";
import {CertificateModalService} from "../../services/certificate-modal.service";
import {CertificateFile} from "../../types/certificate-modal.types";
import {certificateFilesResourceType} from "../../configs/certificate-modal-config";
import {LoadingService} from "../../../../../../../../core/services/loading.service";
import {AttachFileParams} from "../../../../../../../../core/types/file.types";
import {FileCardComponent} from "../../../../../../../../shared/components/ui/file-card/file-card.component";
import {
  FileUploadCardComponent
} from "../../../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";

@Component({
  selector: 'div[app-certificate-files]',
  imports: [
    FileCardComponent,
    FileUploadCardComponent
  ],
  templateUrl: './certificate-files.component.html',
  styleUrl: './certificate-files.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CertificateFilesComponent implements OnInit {
  certificateId = input<number>(0);
  isEditModeActive = input<boolean>(false);

  private certificateModalService: CertificateModalService = inject(CertificateModalService);
  private certificateFilesStateService: CertificateFilesStateService = inject(CertificateFilesStateService);
  private loadingService: LoadingService = inject(LoadingService);

  public async ngOnInit(): Promise<void> {
    await this.getFiles();
  }

  public getFilesById(): Array<CertificateFile> {
    return this.certificateFilesStateService.getCertificateFilesById(this.certificateId());
  }

  public async handleDelete(isImage: boolean, file: CertificateFile):  Promise<void> {
    const deleteFileParams: DeleteFileParams = {
      path: certificateFilesResourceType.path,
      id: file.id
    };

    this.certificateModalService.deleteFile(deleteFileParams)
      .then(() => this.certificateFilesStateService.deleteFileById(file.id, this.certificateId()));
  }

  public async attachFile({ parentId, fileId }: AttachFileParams): Promise<void> {
    const attachFileParams: AttachProductCardFileParams = {
      path: certificateFilesResourceType.path,
      body: {
        fileId: fileId,
        certificateId: parentId
      }
    };

    await this.certificateModalService.attachFile<CertificateFile>(attachFileParams)
      .then((data) => this.certificateFilesStateService.updateCertificateFilesState(this.certificateId(), data));
  }

  private async getFiles(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    const params: GetFilesParams = {
      path: certificateFilesResourceType.path,
      params: { certificateId: this.certificateId() }
    };

    await this.certificateModalService.getFiles(params)
      .then((data) => this.certificateFilesStateService.setCertificateFilesState(this.certificateId(), data))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
